var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.travelPlan)?_c('travel-preview',{attrs:{"plan-preview":_vm.travelPlan}}):_c('travel-preview'),_c('section',[_c('tabs-navigation',{attrs:{"current-tab":'plan'}}),_c('div',{staticClass:"tabs__content"},[(_vm.travelPlan)?_c('tab-content-plan',{attrs:{"travel":_vm.travelPlan}}):_c('p',[_vm._v(_vm._s(_vm.$t("no-plan")))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }